/**
 * Production-Ready Environment Configuration
 * 
 * Simple, type-safe, no dependency injection complexity
 */

export interface PartyManagerConfig {
  mongodb: {
    url: string;
    database: string;
    options: {
      maxPoolSize: number;
      minPoolSize: number;
      maxIdleTimeMS: number;
      connectTimeoutMS: number;
      serverSelectionTimeoutMS: number;
    };
  };
  logging: {
    level: 'error' | 'warn' | 'info' | 'debug';
    format: 'json' | 'text';
  };
  health: {
    enabled: boolean;
    path: string;
  };
  metrics: {
    enabled: boolean;
    path: string;
  };
}

/**
 * Get configuration from environment variables with defaults
 */
export function getConfig(): PartyManagerConfig {
  return {
    mongodb: {
      url: process.env.PARTY_MANAGER_MONGO_URL || 'mongodb://localhost:27017',
      database: process.env.PARTY_MANAGER_DB_NAME || 'party_manager',
      options: {
        maxPoolSize: parseInt(process.env.MONGO_MAX_POOL_SIZE || '10'),
        minPoolSize: parseInt(process.env.MONGO_MIN_POOL_SIZE || '2'),
        maxIdleTimeMS: parseInt(process.env.MONGO_MAX_IDLE_TIME || '60000'),
        connectTimeoutMS: parseInt(process.env.MONGO_CONNECT_TIMEOUT || '10000'),
        serverSelectionTimeoutMS: parseInt(process.env.MONGO_SERVER_TIMEOUT || '5000')
      }
    },
    logging: {
      level: (process.env.LOG_LEVEL || 'info') as any,
      format: (process.env.LOG_FORMAT || 'json') as any
    },
    health: {
      enabled: process.env.HEALTH_CHECK_ENABLED !== 'false',
      path: process.env.HEALTH_CHECK_PATH || '/health'
    },
    metrics: {
      enabled: process.env.METRICS_ENABLED === 'true',
      path: process.env.METRICS_PATH || '/metrics'
    }
  };
}

/**
 * Validate configuration at startup
 */
export function validateConfig(config: PartyManagerConfig): void {
  if (!config.mongodb.url) {
    throw new Error('MongoDB URL is required');
  }
  
  if (!config.mongodb.database) {
    throw new Error('MongoDB database name is required');
  }
  
  if (config.mongodb.options.maxPoolSize < config.mongodb.options.minPoolSize) {
    throw new Error('MongoDB maxPoolSize must be >= minPoolSize');
  }
}